<div class="ss-loader-container">
  <kendo-loader type="converging-spinner"></kendo-loader>
</div>
